/* Bookly cart: live totals + AJAX quantity sync (Shopify cart/change.js)
   - Updates unit/line prices and summary immediately
   - Keeps server cart in sync (no need to press "Oppdater handlekurv")
*/
(function () {
  var cartRoot = document.querySelector('.bookly-cart');
  if (!cartRoot) return;

  // If we are already on the empty-cart view, do nothing.
  // Running the live updater on an empty cart can create reload loops.
  if (cartRoot.querySelector('.bookly-empty-cart')) return;

  var moneyFormat = window.BOOKLY_MONEY_FORMAT || '{{amount}} kr';

  function defaultOption(option, defaultValue) {
    return typeof option === 'undefined' ? defaultValue : option;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, '.');
    decimal = defaultOption(decimal, ',');

    if (isNaN(number) || number === null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    cents = parseInt(cents, 10) || 0;
    format = format || moneyFormat;

    var placeholderMatch = format.match(/\{\{(.*?)\}\}/);
    var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';

    var value;
    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, '.', ',');
    }

    return format.replace(/\{\{(.*?)\}\}/, value);
  }

  function setMoney(el, cents) {
    if (!el) return;
    el.textContent = formatMoney(cents);
  }

  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var totalEl = document.querySelector('[data-cart-total]');

  function updateHeaderCount(count) {
    var selectors = ['[data-cart-count]', '.cart-count-bubble span', '.header__cart-count', '.cart-count'];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = String(count);
      });
    });

    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      if (count <= 0) b.classList.add('hidden');
      else b.classList.remove('hidden');
    });
  }

  async function changeLine(line, quantity) {
    var res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    });

    if (!res.ok) {
      throw new Error('Cart change failed: ' + res.status);
    }

    return await res.json();
  }

  function render(cart) {
    setMoney(subtotalEl, cart.items_subtotal_price);
    setMoney(totalEl, cart.total_price);
    updateHeaderCount(cart.item_count);
    updateCartItemCountLabel(cart.item_count);

    cart.items.forEach(function (item, idx) {
      var line = idx + 1;
      var row = document.querySelector('.bookly-cart-item[data-line="' + line + '"]');
      if (!row) return;

      var input = row.querySelector('[data-qty-input]');
      if (input) input.value = item.quantity;

      var unitEl = row.querySelector('[data-unit-price]');
      if (unitEl) unitEl.textContent = formatMoney(item.final_price);

      var lineEl = row.querySelector('[data-line-price]');
      if (lineEl) lineEl.textContent = formatMoney(item.final_line_price);
    });

    // Remove rows that no longer exist (if items were removed)
    document.querySelectorAll('.bookly-cart-item').forEach(function (row) {
      var line = parseInt(row.getAttribute('data-line'), 10);
      if (line && line > cart.items.length) {
        row.remove();
      }
    });

    if (cart.item_count === 0) {
      // Redirect once to ensure we get the proper server-rendered empty cart markup.
      // Prevents the cart page from getting stuck in a refresh loop.
      try {
        var key = 'bookly_cart_empty_redirected';
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, '1');
          window.location.href = '/cart';
        }
      } catch (e) {
        // Fallback: do nothing if sessionStorage is blocked.
      }
      return;
    }

    // Clear redirect flag once cart has items again
    try { sessionStorage.removeItem('bookly_cart_empty_redirected'); } catch (e) {}
  }

  function updateCartItemCountLabel(count) {
    var targets = document.querySelectorAll('[data-cart-count]');
    if (!targets || !targets.length) return;

    var n = Number(count) || 0;
    var unit = (n === 1) ? 'bok' : 'bøker';
    var text = '(' + n + ' ' + unit + ')';
    targets.forEach(function (el) {
      el.textContent = text;
    });
  }

  function getRowLine(row) {
    var line = parseInt(row.getAttribute('data-line'), 10);
    return isNaN(line) ? null : line;
  }

  function clampQty(q) {
    q = parseInt(q, 10);
    if (isNaN(q) || q < 0) q = 0;
    if (q > 999) q = 999;
    return q;
  }

  var busyLines = new Set();

  async function syncRow(row, newQty) {
    var line = getRowLine(row);
    if (!line) return;
    if (busyLines.has(line)) return;

    busyLines.add(line);
    row.classList.add('is-loading');
    row.setAttribute('aria-busy', 'true');

    try {
      var cart = await changeLine(line, newQty);
      render(cart);
    } catch (err) {
      console.error(err);
      try {
        var cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (cartRes.ok) {
          var cart = await cartRes.json();
          render(cart);
        }
      } catch (e) {
        // ignore
      }
    } finally {
      row.classList.remove('is-loading');
      row.removeAttribute('aria-busy');
      busyLines.delete(line);
    }
  }

  cartRoot.addEventListener('click', function (e) {
    var target = e.target;

    var inc = target.closest('[data-qty-inc]');
    var dec = target.closest('[data-qty-dec]');
    var remove = target.closest('[data-remove]');

    if (!(inc || dec || remove)) return;

    var row = target.closest('.bookly-cart-item');
    if (!row) return;

    if (remove) {
      e.preventDefault();
      syncRow(row, 0);
      return;
    }

    var input = row.querySelector('[data-qty-input]');
    if (!input) return;

    var current = clampQty(input.value);
    var next = current + (inc ? 1 : -1);
    if (next < 0) next = 0;

    input.value = next;
    syncRow(row, next);
  });

  cartRoot.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;

    var row = input.closest('.bookly-cart-item');
    if (!row) return;

    var next = clampQty(input.value);
    input.value = next;
    syncRow(row, next);
  });

  // Initial sync to ensure summary and line totals are consistent
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (cart) {
      if (cart) render(cart);
    })
    .catch(function () {
      // ignore
    });
})();
